"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _services = require("@alycecom/services");

var _useGetTeamMembersByTeamId = require("../../../../../Shared/Teams/hooks/useGetTeamMembersByTeamId");

var _SelectTeamMember = require("../../../../../Shared/Teams/components/SelectTeamMember");

var _user = require("../../../../../Shared/store/user/user.selectors");

var _members = require("../../../../../Shared/Teams/store/members/members.helpers");

var _providers = require("../../../../providers");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    avatar: {
      height: 60,
      width: 60,
      marginRight: spacing(2)
    },
    fakeAvatar: {
      backgroundColor: palette.divider
    },
    fakeAvatarIcon: {
      width: 'initial',
      color: palette.common.white,
      fontSize: '2rem',
      height: '2rem'
    },
    users: {
      color: palette.grey.main,
      overflow: 'hidden',
      marginRight: 5
    },
    integrationIssue: {
      color: palette.warning.main
    },
    sendAsLink: {
      color: palette.link.main,
      fontSize: '16px',
      display: 'flex',
      flexDirection: 'row',
      alignContent: 'center',
      flexWrap: 'wrap',
      cursor: 'pointer'
    },
    calendarIssues: {
      fontSize: '16px',
      display: 'flex',
      flexDirection: 'row',
      alignContent: 'center',
      flexWrap: 'wrap',
      cursor: 'pointer'
    },
    collapsedUsers: {
      maxHeight: 100,
      overflow: 'scroll'
    }
  };
});

var SendAsPreview = function SendAsPreview(_ref2) {
  var teamId = _ref2.teamId,
      sendAsPersons = _ref2.sendAsPersons;
  var classes = useStyles();
  var connectionHint = 'This email is not connected with a calendar.\n' + 'Please ask to connect a calendar in the account settings, otherwise, Alyce will not be able to send invitations and book meetings on behalf of the team member.';

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex.batchId;

  var _useGetTeamMembersByT = (0, _useGetTeamMembersByTeamId.useGetTeamMembersByTeamId)(teamId),
      useGetAll = _useGetTeamMembersByT.useGetAll;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      localSendAs = _useState4[0],
      setLocalSendAs = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isSendAsChooseOpen = _useState6[0],
      setIsSendAsChooseOpen = _useState6[1];

  var currentUserId = (0, _reactRedux.useSelector)(_user.getUserId);

  var _useGetTeamMembersByT2 = (0, _useGetTeamMembersByTeamId.useGetTeamMembersByTeamId)(teamId),
      isTeamMembersPending = _useGetTeamMembersByT2.isPending;

  var getTeamMemberLabel = function getTeamMemberLabel(teamMember) {
    var mySelfPrefix = teamMember.id === currentUserId ? ' (myself)' : '';
    return "".concat(teamMember.firstName, " ").concat(teamMember.lastName).concat(mySelfPrefix);
  };

  var sortTeamMembers = (0, _react.useMemo)(function () {
    return (0, _members.makeSortTeamMembers)(currentUserId);
  }, [currentUserId]);
  var teamMembers = useGetAll();
  var isSendAsHaveCalendarIssues = (0, _react.useMemo)(function () {
    var result = true;
    sendAsPersons.forEach(function (member) {
      if (!result) {
        return;
      }

      result = member.hasIntegrationConnected;
    });
    return !result;
  }, [sendAsPersons]);
  var mappedTeamMembers = (0, _react.useMemo)(function () {
    var result = {};
    teamMembers.forEach(function (member) {
      result[member.id] = member;
    });
    return result;
  }, [teamMembers]);

  var _usePutSendAsProspect = (0, _services.usePutSendAsProspectingBatchByIdMutation)(),
      _usePutSendAsProspect2 = (0, _slicedToArray2.default)(_usePutSendAsProspect, 1),
      putSendAsProspectingBatchById = _usePutSendAsProspect2[0];

  var handleSetOneSender = (0, _react.useCallback)(function () {
    if (batchId && localSendAs) {
      var targetSendAs = mappedTeamMembers[localSendAs];
      putSendAsProspectingBatchById({
        batchId,
        targetSendAs
      }).unwrap().then(function () {
        (0, _services.showGlobalMessage)({
          type: _services.MessageType.Success,
          text: 'Send as person was updated.'
        });
        setIsSendAsChooseOpen(false);
      });
    }
  }, [batchId, localSendAs, mappedTeamMembers, putSendAsProspectingBatchById]);

  var chooseSendAs = /*#__PURE__*/_react.default.createElement(_ui.ModalConfirmationMessage, {
    title: "Select one sender",
    icon: "user",
    width: 600,
    isOpen: isSendAsChooseOpen,
    onSubmit: handleSetOneSender,
    onDiscard: function onDiscard() {
      return setIsSendAsChooseOpen(false);
    },
    submitButtonText: "Ok",
    cancelButtonText: "Cancel",
    variant: "success"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_SelectTeamMember.SelectTeamMember, {
    teamId: teamId,
    value: localSendAs,
    label: "Select sender",
    onChange: function onChange(_ref3) {
      var target = _ref3.target;
      return setLocalSendAs(target === null || target === void 0 ? void 0 : target.value);
    },
    disabled: isTeamMembersPending,
    renderOptionLabel: getTeamMemberLabel,
    sortOptions: sortTeamMembers,
    fullWidth: true
  })));

  if (sendAsPersons && sendAsPersons.length > 1) {
    return /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      justifyContent: "space-between"
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      display: "flex",
      onClick: function onClick() {
        return setIsOpen(!isOpen);
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      className: classes.sendAsLink
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, null, "".concat(sendAsPersons.length, " senders uploaded")), /*#__PURE__*/_react.default.createElement(_material.Grid, null, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      style: {
        paddingLeft: '5px'
      },
      fontSize: 0.7,
      size: "xs",
      icon: isOpen ? 'angle-up' : 'angle-down'
    })))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      className: classes.calendarIssues
    }, isSendAsHaveCalendarIssues && /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: classes.integrationIssue
    }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "calendar"
    }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      display: "inline",
      pl: 1
    }, "Email & calendar problem"))), /*#__PURE__*/_react.default.createElement(_material.Grid, null, /*#__PURE__*/_react.default.createElement(_ui.Button, {
      variant: "outlined",
      onClick: function onClick() {
        return setIsSendAsChooseOpen(true);
      }
    }, "Set one send as"))), /*#__PURE__*/_react.default.createElement(_ui.Divider, null), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
      in: isOpen,
      collapsedSize: 130,
      className: classes.collapsedUsers,
      unmountOnExit: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      direction: "column",
      pt: 2
    }, sendAsPersons.map(function (sender) {
      return /*#__PURE__*/_react.default.createElement(_material.Grid, {
        container: true,
        item: true,
        justifyContent: "space-between",
        paddingY: 0.5
      }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
        item: true,
        style: {
          width: 220,
          flex: '1 1 0px'
        }
      }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
        title: sender.sendAsEmail,
        className: classes.users
      }, sender.sendAsEmail)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
        item: true,
        style: {
          width: 210
        }
      }, !sender.hasIntegrationConnected && /*#__PURE__*/_react.default.createElement(_material.Typography, {
        className: classes.integrationIssue
      }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
        display: "inline",
        pr: 1
      }, "Calendar is disconnected"), /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
        style: {
          display: 'inline'
        },
        placement: "top",
        title: connectionHint
      }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
        icon: "info-circle",
        color: "#9b9b9b"
      })))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
        item: true,
        style: {
          width: 100,
          display: 'flex',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
        className: classes.users
      }, sender.contactsCount, " contacts")));
    }))), chooseSendAs);
  }

  var sendAs = teamMembers.find(function (member) {
    return sendAsPersons && member.email === sendAsPersons[0].sendAsEmail;
  });
  var fullName = "".concat(sendAs === null || sendAs === void 0 ? void 0 : sendAs.firstName, " ").concat(sendAs === null || sendAs === void 0 ? void 0 : sendAs.lastName);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    flexDirection: "row",
    alignItems: "center",
    style: {
      display: 'flex',
      flex: '1 1 0px'
    }
  }, sendAs !== null && sendAs !== void 0 && sendAs.imageUrl ? /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    src: sendAs === null || sendAs === void 0 ? void 0 : sendAs.imageUrl,
    className: classes.avatar,
    alt: fullName
  }) : /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    alt: fullName,
    className: (0, _classnames.default)(classes.avatar, classes.fakeAvatar)
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "user",
    className: classes.fakeAvatarIcon
  })), /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static-Bold"
  }, fullName), /*#__PURE__*/_react.default.createElement("a", {
    className: "Subcopy-Regular-Link",
    href: "mailto:".concat(sendAs === null || sendAs === void 0 ? void 0 : sendAs.email)
  }, sendAs === null || sendAs === void 0 ? void 0 : sendAs.email))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex"
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    variant: "outlined",
    onClick: function onClick() {
      return setIsSendAsChooseOpen(true);
    }
  }, "Set another sender")), chooseSendAs);
};

var _default = /*#__PURE__*/(0, _react.memo)(SendAsPreview);

exports.default = _default;